import { httpService } from '~/Services/Service';

// Backend: cobrador/acordo-judicial/* (RoutePrefix sem api/). Fonte Delphi: UConsultaJudicial.pas.
// Campos snake_case (bridge JSON global). data = ontem 23:59:59 resolvido no backend (RN-16).
const BASE = '/cobrador/acordo-judicial';

// Combo GE escopado por usuário (RN-08).
export const listarGruposEmpresa = () =>
  httpService.get(`${BASE}/grupos-empresa`);

// Combo praça/cidade.
export const listarCidades = () => httpService.get(`${BASE}/cidades`);

// Combo empreendimento.
export const listarEmpreendimentos = () =>
  httpService.get(`${BASE}/empreendimentos`);

// Combo cobrador JÁ escopado por nível (backend aplica pezao/sojuris). Re-busca quando GE muda (RN-14).
export const listarCobradores = ge => {
  const sufixo = ge ? `?ge=${ge}` : '';
  return httpService.get(`${BASE}/cobradores${sufixo}`);
};

// Query principal — acordos judiciais agrupados por boleto. Todos os filtros opcionais.
export const consultarAcordoJudicial = filtros => {
  const partes = [];
  if (filtros && filtros.ge) partes.push(`ge=${filtros.ge}`);
  if (filtros && filtros.cidade) partes.push(`cidade=${filtros.cidade}`);
  if (filtros && filtros.empreendimento)
    partes.push(`empreendimento=${filtros.empreendimento}`);
  if (filtros && filtros.cobrador) partes.push(`cobrador=${filtros.cobrador}`);
  const query = partes.length ? `?${partes.join('&')}` : '';
  return httpService.get(`${BASE}${query}`);
};
